import { Component, OnInit, HostListener, Output, EventEmitter, ViewChild } from '@angular/core';
import { environment } from './../../environments/environment';
import { NewsfeedService } from './../_services/newsfeed.service';

@Component({
  selector: 'app-giphy',
  templateUrl: './giphy.component.html',
  styleUrls: ['./giphy.component.scss']
})

@HostListener('scroll', ['$event'])

export class GiphyComponent implements OnInit {
  defaultURL: String = null;
  search: String = '';
  results = [];
  searchTimer: any = null;
  offset = 0;
  selected = null;
  @Output() setGIF: EventEmitter<any> = new EventEmitter();
  @ViewChild('postboxInput') postboxInputElement: any;

  constructor(private _newsFeedService: NewsfeedService) {
    this.defaultURL = `${environment.assetURL}`+'/assets/default';
  }

  ngOnInit() {
    setTimeout(() => this.postboxInputElement.nativeElement.focus());
  }

  selectGIF(url){
    this.selected = url;
    this.setGIF.emit(this.selected);
    this.search = '';
    this.results = [];
  }

  searchTerm(event){
    clearTimeout(this.searchTimer);
    this.offset = 0;
    this.results = [];
    this.selected = null;
    this.setGIF.emit(this.selected);
    this.searchTimer = setTimeout(() => {
      this._newsFeedService.searchGiphy(this.search, this.offset, 30).subscribe(state => {
        state.data.forEach(gif => {
          this.results.push({
            display:gif.images.preview_gif.url,
            actual:gif.images.original.url
          });
        });
      });
    }, 800);
  }

  loadMore(){
    if (this.results.length == this.offset + 30){ // are there more results to be loaded?
      this.offset += 30;
      this._newsFeedService.searchGiphy(this.search, this.offset, 30).subscribe(state => {
        state.data.forEach(gif => {
          this.results.push({
            display:gif.images.preview_gif.url,
            actual:gif.images.original.url
          });
        });
      });
    }
  }

  resultsScroll(event){
    if (event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop < 50) this.loadMore();
  }

}
